export default __webpack_public_path__ + "static/media/info_02.ca0ac55e.png";